import React from 'react';
import { ConfigProvider, Layout } from 'antd'
import { Outlet } from 'react-router-dom';
import './App.css';
import { ScrollRestoration } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import { theme } from '../config/theme';
import { ConfiguratorStateProvider } from '../routes/Configurator/context';

const { Content } = Layout;

const App: React.FC = () => {

    return (
        <ConfigProvider
            theme={theme}
        >
            <ConfiguratorStateProvider>
                <Layout>
                    <Header />
                    <Content className='content'>
                        <Outlet />
                    </Content>

                    <Footer />
                </Layout>
            </ConfiguratorStateProvider>
            <ScrollRestoration />
        </ConfigProvider >

    );
}

export default App;
